import React from 'react';
import ReactDOM from 'react-dom';
import {Route, BrowserRouter as Router, Switch} from 'react-router-dom'
import './index.css';
import * as serviceWorker from './serviceWorker';

import {I18nextProvider} from 'react-i18next';
import i18next from 'i18next';
import mainNL from "./translations/nl/main"
import mainEn from "./translations/en/main"

import RouteHome from "./RouteHome";
import RouteAbout from "./RouteAbout";
import RouteServices from "./RouteServices";
import RouteContact from "./RouteContact";
import RouteNotFound from "./RouteNotFound";
// import RouteAdmin from "./RouteAdmin";
// import AdminEditPage from "./RouteAdmin/AdminEditPage"

i18next.init({
    interpolation: {escapeValue: false},
    lng: localStorage.getItem("Language") ? localStorage.getItem("Language") : "nl",
    resources: {
        en: {
            main: mainEn
        },
        nl: {
            main: mainNL
        },
    },
});

const routing = (
    <I18nextProvider i18n={i18next}>
        <Router>
            <div>
                <Switch>
                    <Route exact path="/" component={RouteHome}/>
                    <Route path="/about" component={RouteAbout}/>
                    <Route path="/services" component={RouteServices}/>
                    <Route path="/contact" component={RouteContact}/>
                    <Route component={RouteNotFound}/>
                </Switch>
            </div>
        </Router>
    </I18nextProvider>
);

ReactDOM.render(routing, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
